import * as Yup from 'yup'
import { safeStringSchema } from 'utils/validation'

const differentRecipientSchema = (validationSchema) =>
  Yup.string().when('isDifferentRecipient', {
    is: true,
    then: validationSchema,
  })

export const couponCheckoutValidationSchema = () =>
  Yup.object().shape({
    isGuest: Yup.bool(),
    isDifferentRecipient: Yup.bool(),
    paymentOption: Yup.string(),
    amount: Yup.number('Amount must be a number')
      // Eslint have some problem with Yup substitution
      // eslint-disable-next-line no-template-curly-in-string
      .min(100, 'Minimum amount is $${min}')
      .max(999999, 'Maximum amount is $999,999')
      .integer('Please use only whole numbers')
      .label('Amount')
      .required(),
    contactEmail: Yup.string().when('isGuest', {
      is: true,
      then: Yup.string().email().required().label('Email').trim(),
    }),
    recipientEmail: differentRecipientSchema(
      Yup.string().email().label("Recipient's e-mail").max(100).trim()
    ),
    recipientMessage: differentRecipientSchema(
      Yup.string().when('recipientEmail', {
        is: (value) => Boolean(value),
        then: Yup.string()
          .label('Message to the recipient')
          .max(500)
          .required(),
      })
    ),
    recipientFirstName: differentRecipientSchema(
      Yup.string().when('recipientEmail', {
        is: (value) => Boolean(value),
        then: safeStringSchema
          .label("Recipient's first name")
          .max(100)
          .required(),
      })
    ),
    buyerFullName: differentRecipientSchema(
      Yup.string().when('recipientEmail', {
        is: (value) => Boolean(value),
        then: safeStringSchema.label('Your Full name').max(200).required(),
      })
    ),
  })
